"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconSkipBack15 = Experimental__IconSkipBack15;
exports.IconSkipBack15 = IconSkipBack15;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconSkipBack15/index.tsx)
 */
function IconSkipBack15(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M2.464 4.5h1.473a.75.75 0 0 1 0 1.5H0V2.063a.75.75 0 0 1 1.5 0v1.27a8.25 8.25 0 1 1 10.539 12.554.75.75 0 0 1-.828-1.25A6.75 6.75 0 1 0 2.464 4.5Z\'/><path d=\'M0 10.347V9.291c.697-.051 1.199-.18 1.507-.385.315-.205.51-.51.583-.913h1.32v7.81H1.903v-5.456H0Zm7.322 5.643c-.543 0-1.03-.099-1.463-.297a2.46 2.46 0 0 1-1.023-.869c-.25-.389-.382-.85-.396-1.386h1.518c.007.242.066.455.176.638.11.183.26.326.45.43.191.102.411.153.66.153.257 0 .48-.059.672-.176.198-.117.348-.282.45-.495.11-.213.166-.454.166-.726 0-.271-.055-.51-.165-.715a1.135 1.135 0 0 0-.451-.495 1.254 1.254 0 0 0-.671-.176c-.286 0-.536.07-.748.21a1.23 1.23 0 0 0-.462.516H4.56L5 7.993h4.642V9.39H6.207l-.211 2.134c.057-.108.136-.214.237-.319a1.77 1.77 0 0 1 .616-.407c.249-.103.52-.154.814-.154.454 0 .861.103 1.22.308.367.206.653.499.859.88.205.381.308.825.308 1.331 0 .528-.11 1.008-.33 1.441-.22.426-.54.763-.957 1.012-.411.25-.891.374-1.441.374Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M5.286 6H7.25a1 1 0 1 1 0 2H2V2.75a1 1 0 1 1 2 0v1.694A10.97 10.97 0 0 1 11.994 1c6.075 0 11 4.925 11 11a10.99 10.99 0 0 1-4.943 9.183 1 1 0 1 1-1.102-1.668A9 9 0 1 0 5.286 6Z\'/><path d=\'M11.024 22.28c-.728 0-1.381-.127-1.96-.379a3.14 3.14 0 0 1-1.358-1.12c-.336-.494-.513-1.082-.532-1.764h2.03c.01.299.084.565.224.798.15.234.35.416.602.546.262.122.56.182.896.182.355 0 .658-.07.91-.21a1.53 1.53 0 0 0 .602-.616c.14-.261.21-.564.21-.91 0-.336-.07-.634-.21-.896a1.44 1.44 0 0 0-.602-.602 1.725 1.725 0 0 0-.896-.224 1.89 1.89 0 0 0-1.008.266 1.575 1.575 0 0 0-.63.63h-1.96l.588-5.88h6.23v1.834H9.542l-.27 2.625c.07-.116.16-.23.268-.343.224-.224.509-.401.854-.532.346-.14.719-.21 1.12-.21a3.31 3.31 0 0 1 1.638.406c.486.262.864.635 1.134 1.12.271.486.406 1.05.406 1.694 0 .672-.149 1.284-.448 1.834-.298.542-.728.97-1.288 1.288-.55.308-1.194.462-1.932.462ZM1.04 15.181v-1.4c.914-.065 1.577-.228 1.987-.49.41-.27.663-.667.756-1.19h1.778v9.94H3.545v-6.86H1.04Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconSkipBack15 is deprecated and will be archived soon. Use IconSkipBack15 instead.
 */
function Experimental__IconSkipBack15(props) {
  return /*#__PURE__*/_react["default"].createElement(IconSkipBack15, props);
}